import React, { useRef, useEffect, forwardRef } from 'react'
import classNames from 'classnames'
import { Form } from 'react-bootstrap'
import IFormFieldProps from 'interfaces/form-field-props'
import ErrorField from '../error-field/ErrorField'
import InputLabel from '../input-label/InputLabel'
import styles from './TextInput.module.scss'

type OnChange = React.ChangeEventHandler<
  HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
>

const TextInput = forwardRef<HTMLInputElement, IFormFieldProps<OnChange>>(
  (
    {
      name,
      value,
      label,
      placeHolder,
      disabled,
      type = 'text',
      onChange,
      error = '',
      className,
      classes,
      isInvalid,
      isValid,
      formControlProps,
      size,
      onBlur,
    },
    rootRef
  ) => {
    const ref = useRef<HTMLInputElement>()
    useEffect(() => {
      if (value != null && ref.current) {
        if (type === 'number') {
          if (
            (value === 0 && ref.current.value === '') ||
            // eslint-disable-next-line
            ref.current.value != value
          ) {
            ref.current.value = '' + value
          } else if (value !== 0 && ref.current.value !== '' + value) {
            ref.current.value = '' + value
          }
        } else if (ref.current.value !== '' + value) {
          ref.current.value = '' + value
        }
      }
    }, [type, value])

    return (
      <>
        {label && <InputLabel label={label} className={classes?.label} />}
        <Form.Control
          name={name}
          ref={(e) => {
            ref.current = e
            if (rootRef)
              if (typeof rootRef === 'function') rootRef(e)
              else rootRef.current = e
          }}
          value={value}
          type={type}
          placeholder={placeHolder}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          size={size}
          className={classNames(styles.text, className, classes?.input)}
          {...{ isInvalid: isInvalid ?? !!error, isValid }}
          {...formControlProps}
        />
        {error && <ErrorField text={error} />}
      </>
    )
  }
)

export default TextInput
